import React from 'react';
import styles from './Coordinates.module.css';

interface CoordinatesProps {
  orientation: 'white' | 'black';
  type: 'files' | 'ranks';
}

export const Coordinates: React.FC<CoordinatesProps> = ({ orientation, type }) => {
  const files = orientation === 'white' 
    ? ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']
    : ['h', 'g', 'f', 'e', 'd', 'c', 'b', 'a'];
    
  const ranks = orientation === 'white'
    ? ['8', '7', '6', '5', '4', '3', '2', '1']
    : ['1', '2', '3', '4', '5', '6', '7', '8'];
  
  if (type === 'files') {
    return (
      <div className={styles.files}>
        {files.map(file => (
          <div key={file} className={styles.coordinate}>
            {file}
          </div>
        ))}
      </div>
    );
  }
  
  return (
    <div className={styles.ranks}>
      {ranks.map(rank => (
        <div key={rank} className={styles.coordinate}>
          {rank}
        </div>
      ))}
    </div>
  );
};